import React from 'react'
import PropTypes from 'prop-types'
import { classNames } from 'utils/utils'
import strings from 'utils/strings'

import { Badge } from 'components/patterns'
import withStyle from './EvaluationBadge.style.js'

const EvaluationBadge = ({ className, selected, value, dataTestId }) => (
  <Badge
    className={classNames(className, 'evaluation-badge')}
    type={selected ? 'selected' : value.toString()}
    text={value ? strings.true_abbr : strings.false_abbr}
    dataTestId={dataTestId}
  />
)

EvaluationBadge.defaultProps = {
  value: '',
}

EvaluationBadge.propTypes = {
  /** Classname */
  className: PropTypes.string,
  value: PropTypes.bool,
  selected: PropTypes.bool,
  dataTestId: PropTypes.string,
}

export default withStyle(EvaluationBadge)
